import React from 'react';
import { FaUsers, FaShieldAlt, FaSyncAlt, FaChartLine, FaServer } from 'react-icons/fa';
import './TallyPrimeServer.css';

const TallyPrimeServer = () => {
  return (
    <div className="tally-server-wrapper">
      {/* ── Hero Section ── */}
      <header className="server-hero">
        <div className="server-hero-main">
          <div className="server-hero-content">
            <h1>TallyPrime Server</h1>
            <p>
              Designing secure, scalable, and highly efficient business setups.
              Empower your office with advanced concurrency, secured data access,
              and real-time monitoring capabilities.
            </p>
          </div>
          <div className="server-hero-visual">
            <img src="/images/server.webp" alt="TallyPrime Server Visual" className="server-hero-img" />
          </div>
        </div>
      </header>

      {/* ── Key Benefits Grid ── */}
      <section className="server-benefits-container">
        <div className="benefits-intro">
          <h2>Key Advantages</h2>
        </div>
        <div className="server-benefits-grid">
          <BenefitCard
            title="High Concurrency"
            icon={<FaUsers />}
            content="Multiple users can perform operations like recording vouchers and generating reports simultaneously without any performance lag."
          />
          <BenefitCard
            title="Secured by Design"
            icon={<FaShieldAlt />}
            content="Advanced security settings provide controlled access to data while ensuring protection against unauthorized data file access."
          />
          <BenefitCard
            title="High Reliability"
            icon={<FaSyncAlt />}
            content="A robust infrastructure that ensures high system availability and smooth operations even during unexpected interruptions."
          />
          <BenefitCard
            title="Process Optimization"
            icon={<FaChartLine />}
            content="Enhanced monitoring and tracking capabilities allow you to streamline business processes and maximize overall productivity."
          />
        </div>
      </section>

      {/* ── Contact for Pricing Section ── */}
      <section className="server-pricing-section">
        <div className="server-pricing-card">
          <div className="pricing-card-header">
            <h2>Licensing & Pricing</h2>
            <p>Empower your enterprise with professional TallyPrime Server solutions.</p>
          </div>

          <div className="pricing-card-body">
            <div className="perpetual-badge">Enterprise Edition</div>
            
            <div className="pricing-cta-message">
              <p>For detailed licensing information, perpetual license pricing, and expert consultation, please reach out to our team.</p>
            </div>

            <p className="pricing-footer-text">
              Designed for medium and large enterprises. <br />
              TallyPrime Server works in conjunction with a TallyPrime Gold license.
            </p>

            <button
              className="server-buy-btn"
              onClick={() => window.location.href = '/contact'}
            >
              Contact Us for Pricing
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

const BenefitCard = ({ title, content, icon }) => {
  return (
    <div className="benefit-card">
      <div className="benefit-icon-wrapper">
        {icon}
      </div>
      <h3>{title}</h3>
      <p>{content}</p>
    </div>
  );
};

export default TallyPrimeServer;
